import { render, staticRenderFns } from "./resource-selection.vue?vue&type=template&id=94fa4d4c&scoped=true"
import script from "./resource-selection.vue?vue&type=script&lang=js"
export * from "./resource-selection.vue?vue&type=script&lang=js"
import style0 from "./resource-selection.vue?vue&type=style&index=0&id=94fa4d4c&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94fa4d4c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/apps/wpms/web/wind-plannerDev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('94fa4d4c')) {
      api.createRecord('94fa4d4c', component.options)
    } else {
      api.reload('94fa4d4c', component.options)
    }
    module.hot.accept("./resource-selection.vue?vue&type=template&id=94fa4d4c&scoped=true", function () {
      api.rerender('94fa4d4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plan/components/resource-selection.vue"
export default component.exports